/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'flexslider';

if ($('#carousel').length > 0 || $('#slider').length > 0 || $('#vidcarousel').length > 0 || $('#vidslider').length > 0) {
  $(document).ready(() => {
    // photo carousels
    $('#carousel').flexslider({
      animation: 'slide',
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 88,
      itemMargin: 5,
      touch: true,
      prevText: '<i class="fa fa-caret-left"></i>',
      nextText: '<i class="fa fa-caret-right"></i>',
      asNavFor: '#slider',
    });

    $('#slider').flexslider({
      animation: 'slide',
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      touch: true,
      sync: '#carousel',
    });

    // product detail carousels
    const $pdfLink = $('.pdfs');
    const $pdfCarousel = $('.pdfcar');
    const $photoLink = $('.photos');
    const $photoCarousel = $('.photocar');
    const $videoLink = $('.videos');
    const $videoCarousel = $('.videocar');

    $photoLink.click((e) => {
      e.preventDefault();

      $pdfCarousel.hide();
      $photoCarousel.show();
      $videoCarousel.hide();

      $pdfLink.removeClass('activeLink');
      $photoLink.addClass('activeLink');
      $videoLink.removeClass('activeLink');
    });

    $videoLink.click((e) => {
      e.preventDefault();

      $pdfCarousel.hide();
      $photoCarousel.hide();
      $videoCarousel.show();

      $pdfLink.removeClass('activeLink');
      $photoLink.removeClass('activeLink');
      $videoLink.addClass('activeLink');

      $('#vidcarousel').flexslider({
        animation: 'slide',
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 88,
        itemMargin: 5,
        touch: true,
        prevText: '<i class="fa fa-caret-left"></i>',
        nextText: '<i class="fa fa-caret-right"></i>',
        asNavFor: '#vidslider',
      });

      $('#vidslider').flexslider({
        animation: 'slide',
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        touch: true,
        sync: '#vidcarousel',
      });
    });

    $pdfLink.click((e) => {
      e.preventDefault();

      $pdfCarousel.show();

      $('#carousel.photocar').hide();
      $('#carousel.videocar').hide();

      $pdfLink.addClass('activeLink');
      $photoLink.removeClass('activeLink');
      $videoLink.removeClass('activeLink');

      $pdfCarousel.flexslider({
        animation: 'slide',
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 88,
        itemMargin: 5,
        touch: true,
      });
    });
  });
}
